exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-status_transitions-components-DealStatus-___style__wrapper___2XbMQ{margin-top:1em}.web-flows-deal-status_transitions-components-DealStatus-___style__wrapper___2XbMQ>h2{border-bottom:none!important}", ""]);

// exports
exports.locals = {
	"wrapper": "web-flows-deal-status_transitions-components-DealStatus-___style__wrapper___2XbMQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/status_transitions/components/DealStatus/style.css
// module id = 1351
// module chunks = 0